<template>


<div class="dashboard">
  <main-menu mstyle="white"></main-menu>

  <div class="plate_settings">
    <p class="title">{{ capitalize(state) }} plate</p>
    <p class="subtitle">7 characters max</p>


    <div class="settings_content">

      <div class="settings_content__img">
        <div class="img_content">
          <img :src="`${static_server}img/plates/${$route.params.state}.png`" />
          <p class="plate_text">{{ plate_text }}</p>
        </div>
      </div>

      <div class="settings_content__modify">
        <p class="modify_top">FEATURED PLATE</p>
        <p class="modify_title">Create your template</p>

        <form @submit.prevent="checkText({plate_text: plate_text, selected_state: $route.params.state})">
          <p class="input_name">Plate text</p>
          <div class="text_round_input">
            <input v-model="plate_text" maxlength="7" style="color: black" required placeholder="Type your plate text" />
            <button type="submit" class="check_button">Check</button>
          </div>
        </form>

        <div class="select_round_input">
          <p class="input_name">Your state</p>
          <select @change="changeState()" v-model="state" class="">
            <option v-for="option in states" :key="option.index" :value="option">
              {{ capitalize(option) }}
            </option>
          </select>
        </div>

        <button class="submit_button" @click="createPlate({data: {text: plate_text, state: state}})">Create your plate</button>

        <button class="submit_button success_button" v-if="is_plate_created" @click="show_modal = true">Download your plate</button>
        <!-- message -->
        <div class="check_message" v-if="check_message.length">
          <div class="img"><img src="@/assets/img/fire.svg" /></div>
          <p>{{ check_message }}</p>
        </div>
      </div>

    </div>

  </div>

  <dashboard-categories></dashboard-categories>

</div>

<modal-window :show="show_modal" @close="show_modal = false" title="Enter your email and get plate">
  <form @submit.prevent="sendForm()">
    <text-input v-model="email" field_name="Your email" :required="true" :round="true" placeholder="alex@gmail.com"></text-input>
    <button class="submit_round_button" type="submit">Get my plate</button>
  </form>
</modal-window>


<full-page-loading v-if="create_loading"></full-page-loading>

<my-footer></my-footer>

</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import MainMenu from './components/MainMenu'
import Footer from './components/Footer'
import DashboardCategories from './dashboard/DashboardCategories.vue'

export default {
  name: 'DetailPlate',
  
  components: {
    'main-menu': MainMenu,
    'my-footer': Footer,
    'dashboard-categories': DashboardCategories
  },

  data() {
    return {
      plate_text: '',
      state: '',
      categories: [],
      email: '',
      show_modal: false,
    }
  },

  watch: {
    '$route.params.state': {
      handler() {
        this.setDetaultValues()
      }
    },

    '$route.params.text': {
      handler() {
        this.setDetaultValues()
      }
    }
  },

  mounted() {
    this.checkCategory()
    this.setDetaultValues()
    this.getCategories()
    document.title = `${this.capitalize(this.$route.params.text)} car number plate in ${this.capitalize(this.$route.params.state)} - vaniplate`
  },

  computed: {
    ...mapState(['static_server', 'server', 'states', 'img_path', 'create_loading', 'check_message', 'media_server', 'is_plate_created'])
  },

  methods: {
    ...mapMutations(['CLEAR_IMG_PATH']),
    ...mapActions(['checkText', 'createPlate']),


    checkCategory() {
      if (!this.states.includes(this.$route.params.state)) {
        this.$router.push('/not_exist')
      }
    },

    getCategories() {
      this.$axios.get(`${this.server}search/${this.state}`)
        .then((response) => {
          this.categories = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },

    sendForm() {
      this.$axios.post(`${this.server}utils/check/`,
        {email: this.email})
        .then((response) => {
          window.open(`${this.media_server}plates/${this.plate_text}__${this.state}.png`, '_blank')
          this.show_modal = false
        })
        .catch((error) => {
          this.show_modal = false
        })
    },

    changeState() {
      this.$router.push(`/${this.state}/${this.plate_text}`)
      this.checkText({plate_text: this.plate_text, selected_state: this.state})
      this.CLEAR_IMG_PATH()
      this.getCategories()
    },

    setDetaultValues() {
      this.state = this.$route.params.state
      this.plate_text = this.$route.params.text
    },

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/style.sass"
</style>